import { render } from "./DTable.vue?vue&type=template&id=4d420bbe"
import script from "./DTable.vue?vue&type=script&lang=js"
export * from "./DTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__